import { defineMessages } from 'react-intl';
export var scope = 'HomePage.header';
export default defineMessages({
  filterButton: {
    id: "".concat(scope, ".filterButton")
  }
});